import * as types from '@/store/types'

export default {
  [types.ADD_ACTION_IN_QUEUE]: (
    { state, commit, dispatch },
    { type, payload, name = types.COMMON }
  ) => {
    const { loadingPromises } = state[types.COMMON]
    const loadingPromise = loadingPromises[name]
    let promise

    if (loadingPromise && loadingPromise.then) {
      promise = loadingPromise.then(() => dispatch(type, payload))
    } else {
      promise = dispatch(type, payload)
    }

    commit(types.SET_PROMISE_CHAIN, { name, promise })

    return promise
  },

  [types.LOADING_DATA]: ({ commit }, message = '') => {
    const name = types.COMMON
    commit(types.LOADING, name)
    commit(types.SET_LOADING_MESSAGE, { name, message })
  },

  [types.LOADED_DATA]: ({ commit }) => {
    const name = types.COMMON
    commit(types.LOADED, name)
    commit(types.SET_LOADING_MESSAGE, { name, message: '' })
  },

  [types.PUSH_NOTIFICATION]: ({ state, commit }, notification) => {
    const name = types.NOTIFICATIONS
    const { list } = state[name]
    const notifications = Array.isArray(notification) ? notification : [notification]
    commit(types.SET_LIST, { name, list: [...list, ...notifications] })
  }
}
